<app-crear-editar
  [title]="title ?? ''"
  [subtitle]="subtitle"
  icono="qr_code_2"
  [loading]="loading || !form"
>
  @if (form) {
    <form
      [formGroup]="form"
      id="form-codigos-dispositivos"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Datos generales -->
      <app-content-card title="Datos generales" icon="info">
        <section class="inputs-group">
          <mat-form-field style="flex: 1">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" required />
            <mat-icon matPrefix>label</mat-icon>
          </mat-form-field>

          @if (helper.esNivel0()) {
            <div class="campo-checkbox">
              <mat-checkbox color="primary" formControlName="global">
                Global
              </mat-checkbox>
            </div>
          }
        </section>
      </app-content-card>

      <!-- Listado de códigos -->
      <app-content-card title="Códigos" icon="integration_instructions">
        <div class="tabla-codigos">
          @if (codigosForm.controls.length) {
            <div class="tabla-codigos-encabezado">
              <span></span>
              <span>Código</span>
              <span>Descripción</span>
              <span>Categoría</span>
              <span></span>
            </div>
          } @else {
            <p class="tabla-codigos-vacia">Todavía no hay códigos cargados.</p>
          }

          <div
            #codigosContainer
            class="codigos-list"
            formArrayName="codigos"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
          >
            @for (f of codigosForm.controls; track f; let i = $index) {
              <div class="codigo-row" [formGroupName]="i" cdkDrag>
                <div class="custom-placeholder" *cdkDragPlaceholder></div>

                <!-- Arrastrar -->
                <mat-icon
                  class="codigo-arrastrar"
                  cdkDragHandle
                  matTooltip="Arrastrar para ordenar"
                >
                  drag_indicator
                </mat-icon>

                <!-- Código -->
                <mat-form-field subscriptSizing="dynamic">
                  <mat-label>Código</mat-label>
                  <input matInput formControlName="codigo" />
                </mat-form-field>

                <!-- Descripción -->
                @if (tipo === 'Tracker') {
                  <app-listado-categoria-selector
                    margin="0"
                    [idCliente]="null"
                    categoria="Evento-Tracker"
                    [categorias]="['Evento-Tracker']"
                    placeholder="Descripción"
                    notFoundText="No hay tipos de eventos"
                    [multiple]="false"
                    [showCrearBtn]="true"
                    [allowCreate]="true"
                    [initialNames]="initialNamesForCodigos[i] ?? []"
                    (listadoCategoriaChange)="onDescripcionChange(i, $event)"
                  ></app-listado-categoria-selector>
                } @else {
                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Descripción</mat-label>
                    <input matInput formControlName="descripcion" />
                  </mat-form-field>
                }

                <!-- Categoría del evento -->
                <ng-select
                  [items]="categoriasEventos"
                  bindValue="_id"
                  formControlName="idCategoriaEvento"
                  placeholder="Categoría"
                  notFoundText="No hay categorías de eventos"
                  [multiple]="false"
                  [searchable]="true"
                  appendTo="body"
                  [searchFn]="searchCategoria"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div class="categoria-opcion">
                      @if (item.global) {
                        <mat-icon class="categoria-global">public</mat-icon>
                      }
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    <div class="categoria-opcion">
                      @if (item.global) {
                        <mat-icon class="categoria-global">public</mat-icon>
                      }
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>
                </ng-select>

                <!-- Quitar -->
                <button
                  irxBotonIcono
                  tono="peligro"
                  type="button"
                  class="codigo-quitar"
                  tooltip="Quitar código"
                  (click)="deleteEvento(i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>

                <!-- Opciones del código según el tipo de dispositivo -->
                @if (
                  tipo === 'Alarma' ||
                  tipo === 'Comunicador' ||
                  tipo === 'Tracker'
                ) {
                  <div class="codigo-opciones">
                    @if (tipo === 'Alarma') {
                      <mat-checkbox color="primary" formControlName="armado">
                        Armado
                      </mat-checkbox>
                      <mat-checkbox color="primary" formControlName="desarmado">
                        Desarmado
                      </mat-checkbox>
                      <mat-checkbox
                        color="primary"
                        formControlName="detonacion"
                      >
                        Detonación
                      </mat-checkbox>
                      <mat-checkbox
                        color="primary"
                        formControlName="mostrarZona"
                      >
                        Mostrar zona
                      </mat-checkbox>
                      <mat-checkbox
                        color="primary"
                        formControlName="mostrarUsuario"
                      >
                        Mostrar usuario
                      </mat-checkbox>
                    }
                    @if (tipo === 'Tracker') {
                      @for (flag of flagsTrackersList; track flag) {
                        <mat-checkbox
                          color="primary"
                          [checked]="hasFlagTracker(f, flag)"
                          (change)="toggleFlagTracker(f, flag, $event.checked)"
                        >
                          {{ flag }}
                        </mat-checkbox>
                      }
                    }
                    <mat-checkbox color="primary" formControlName="test">
                      Test
                    </mat-checkbox>
                    @if (tipo === 'Alarma' || tipo === 'Comunicador') {
                      <mat-checkbox color="primary" formControlName="notificar">
                        Notificar
                      </mat-checkbox>
                    }
                  </div>
                }

                @if (
                  f.get('codigo')?.hasError('codigoRepetido') &&
                  f.get('codigo')?.touched
                ) {
                  <small class="error-duplicado">Código repetido</small>
                }
              </div>
            }
          </div>

          <div class="tabla-codigos-pie">
            <button irxBoton="secundario" type="button" (click)="addCodigo()">
              <mat-icon>add</mat-icon>
              Agregar código
            </button>
          </div>
        </div>
      </app-content-card>

      <!-- Listado de códigos de entrada (sólo trackers) -->
      @if (tipo === 'Tracker') {
        <app-content-card
          title="Códigos de entrada"
          icon="settings_input_component"
        >
          <div class="tabla-codigos">
            @if (codigosEntradaForm.controls.length) {
              <div class="tabla-codigos-encabezado">
                <span></span>
                <span>Código</span>
                <span>Descripción</span>
                <span>Categoría</span>
                <span></span>
              </div>
            } @else {
              <p class="tabla-codigos-vacia">
                Todavía no hay códigos de entrada cargados.
              </p>
            }

            <div
              class="codigos-list"
              formArrayName="codigosEntrada"
              cdkDropList
              (cdkDropListDropped)="dropCodigoEntrada($event)"
            >
              @for (f of codigosEntradaForm.controls; track f; let i = $index) {
                <div class="codigo-row" [formGroupName]="i" cdkDrag>
                  <div class="custom-placeholder" *cdkDragPlaceholder></div>

                  <!-- Arrastrar -->
                  <mat-icon
                    class="codigo-arrastrar"
                    cdkDragHandle
                    matTooltip="Arrastrar para ordenar"
                  >
                    drag_indicator
                  </mat-icon>

                  <!-- Código -->
                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Código</mat-label>
                    <input matInput formControlName="codigo" />
                  </mat-form-field>

                  <!-- Descripción -->
                  <app-listado-categoria-selector
                    margin="0"
                    [idCliente]="null"
                    categoria="Evento-Tracker"
                    [categorias]="['Evento-Tracker']"
                    placeholder="Descripción"
                    notFoundText="No hay tipos de eventos"
                    [multiple]="false"
                    [showCrearBtn]="true"
                    [allowCreate]="true"
                    [initialNames]="initialNamesForCodigosEntrada[i] ?? []"
                    (listadoCategoriaChange)="
                      onDescripcionEntradaChange(i, $event)
                    "
                  ></app-listado-categoria-selector>

                  <!-- Categoría del evento -->
                  <ng-select
                    [items]="categoriasEventos"
                    bindValue="_id"
                    formControlName="idCategoriaEvento"
                    placeholder="Categoría"
                    notFoundText="No hay categorías de eventos"
                    [multiple]="false"
                    [searchable]="true"
                    appendTo="body"
                    [searchFn]="searchCategoria"
                  >
                    <ng-template ng-option-tmp let-item="item">
                      <div class="categoria-opcion">
                        @if (item.global) {
                          <mat-icon class="categoria-global">public</mat-icon>
                        }
                        <span>{{ item.nombre }}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <div class="categoria-opcion">
                        @if (item.global) {
                          <mat-icon class="categoria-global">public</mat-icon>
                        }
                        <span>{{ item.nombre }}</span>
                      </div>
                    </ng-template>
                  </ng-select>

                  <!-- Quitar -->
                  <button
                    irxBotonIcono
                    tono="peligro"
                    type="button"
                    class="codigo-quitar"
                    tooltip="Quitar código de entrada"
                    (click)="deleteEventoEntrada(i)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>

                  @if (
                    f.get('codigo')?.hasError('codigoRepetido') &&
                    f.get('codigo')?.touched
                  ) {
                    <small class="error-duplicado">Código repetido</small>
                  }
                </div>
              }
            </div>

            <div class="tabla-codigos-pie">
              <button
                irxBoton="secundario"
                type="button"
                (click)="addCodigoEntrada()"
              >
                <mat-icon>add</mat-icon>
                Agregar código de entrada
              </button>
            </div>
          </div>
        </app-content-card>
      }
    </form>
  }

  <ng-container actions>
    <button irxBoton="secundario" type="button" (click)="helper.volver()">
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="submit"
      form="form-codigos-dispositivos"
      [disabled]="loading"
    >
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </ng-container>
</app-crear-editar>
